import { CURRENCIES, fx, type CurrencyCode } from '@/lib/currency';
import { DEFAULT_QUOTE_CONFIG, type QuoteTotals as Totals } from '@/lib/quoteMath';

interface QuoteTotalsProps {
  totals: Totals;
  currency: CurrencyCode;
  onCurrency: (c: CurrencyCode) => void;
}

export default function QuoteTotals({ totals, currency, onCurrency }: QuoteTotalsProps) {
  const taxPct = (DEFAULT_QUOTE_CONFIG.taxRate * 100).toFixed(2);
  return (
    <div className="quote-totals">
      <div className="totals-card">
        <div className="row between" style={{ paddingBottom: 12, borderBottom: '1px dashed var(--line-2)', marginBottom: 12 }}>
          <strong style={{ fontFamily: 'var(--mono)', fontSize: 11, letterSpacing: '0.18em', color: 'var(--gold)', textTransform: 'uppercase' }}>
            Adjustments
          </strong>
        </div>
        <div className="quote-controls">
          <label>
            <span className="lbl">Currency</span>
            <select value={currency} onChange={(e) => onCurrency(e.target.value as CurrencyCode)}>
              {CURRENCIES.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </label>
          <label>
            <span className="lbl">Tax Rate</span>
            <input type="text" value={`${taxPct}%`} readOnly style={{ fontFamily: 'var(--mono)' }} />
          </label>
          <label>
            <span className="lbl">Ship Method</span>
            <select>
              <option>FedEx Freight</option>
              <option>R+L Carriers</option>
              <option>Estes</option>
            </select>
          </label>
        </div>
        <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px dashed var(--line-2)', fontSize: 12, color: 'var(--text-dim)', lineHeight: 1.55 }}>
          <strong style={{ color: 'var(--cream)' }}>Shipping calc:</strong>{' '}
          Total weight {totals.totalWeight.toFixed(1)} lbs × ${DEFAULT_QUOTE_CONFIG.shippingRatePerLb.toFixed(2)}/lb = {fx(totals.shipping, currency)} (min ${DEFAULT_QUOTE_CONFIG.shippingMin}).
        </div>
      </div>
      <div className="totals-card">
        <div className="totals-row">
          <span>Subtotal</span>
          <span className="val">{fx(totals.subtotal, currency)}</span>
        </div>
        <div className="totals-row">
          <span>Shipping ({totals.totalWeight.toFixed(1)} lbs)</span>
          <span className="val">{fx(totals.shipping, currency)}</span>
        </div>
        <div className="totals-row">
          <span>Tax ({taxPct}%)</span>
          <span className="val">{fx(totals.tax, currency)}</span>
        </div>
        <div className="totals-row grand">
          <span className="lbl">Grand Total</span>
          <span>{fx(totals.total, currency)}</span>
        </div>
      </div>
    </div>
  );
}
